<div class="page-wrap d-flex flex-row align-items-center">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-md-12 text-center">
        @if (isLoggedIn) {
          <img
          id="error-404"
          src="assets/images/not-found.png"
          alt="not found 404"
        />
          <h1 class="custom-title">{{ text.notFoundTitle }}</h1>
          <div class="mb-4 custom-text">{{ text.notFound }}</div>
        <!-- <a routerLink="/{{ currentRoute }}" class="btn btn-link back-home">{{
          text.backToHome
        }}</a> -->
      } @else {
        <img
        id="error-404"
        src="assets/images/not-found.png"
        alt="not found 404"
      />
        <h1 class="custom-title">{{ text.notFoundTitle }}</h1>
        <div class="mb-4 custom-text">{{ text.notFound }}</div>
        <button routerLink="/login" class="btn btn-danger"
        type="button">
          Voltar ao Login
        </button>
        }
      </div>
    </div>
  </div>
</div>
